import React, { useState } from 'react';
import { Box, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { COMPANY_INFO_FIELD_SX, companyInfoLabelSx } from './companyInfoStyles';

const PasswordField = ({
  id,
  label,
  value,
  onChange,
  placeholder,
  error,
  helperText,
  disabled = false,
  autoComplete = 'new-password',
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <BoxFieldWrapper>
      <Typography component="label" htmlFor={id} sx={companyInfoLabelSx}>
        {label}
      </Typography>
      <TextField
        id={id}
        fullWidth
        type={showPassword ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        error={Boolean(error)}
        helperText={error || helperText}
        autoComplete={autoComplete}
        sx={COMPANY_INFO_FIELD_SX}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label={showPassword ? 'Hide password' : 'Show password'}
                onClick={() => setShowPassword((prev) => !prev)}
                onMouseDown={(event) => event.preventDefault()}
                edge="end"
                size="small"
                disabled={disabled}
                sx={{ color: 'text.disabled' }}
              >
                {showPassword ? (
                  <VisibilityOffOutlinedIcon sx={{ fontSize: 20 }} />
                ) : (
                  <VisibilityOutlinedIcon sx={{ fontSize: 20 }} />
                )}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </BoxFieldWrapper>
  );
};

const BoxFieldWrapper = ({ children }) => <Box sx={{ mb: 2.5 }}>{children}</Box>;

export default PasswordField;
